import { render } from "./hkidrOtcr.vue?vue&type=template&id=5500c251"
import script from "./hkidrOtcr.vue?vue&type=script&lang=js"
export * from "./hkidrOtcr.vue?vue&type=script&lang=js"

import "./hkidrOtcr.vue?vue&type=style&index=0&id=5500c251&lang=less"
script.render = render

export default script